import { render, staticRenderFns } from "./MultipleOssUpload.vue?vue&type=template&id=1fc2d48c&scoped=true&"
import script from "./MultipleOssUpload.vue?vue&type=script&lang=js&"
export * from "./MultipleOssUpload.vue?vue&type=script&lang=js&"
import style0 from "./MultipleOssUpload.vue?vue&type=style&index=0&id=1fc2d48c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc2d48c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fc2d48c')) {
      api.createRecord('1fc2d48c', component.options)
    } else {
      api.reload('1fc2d48c', component.options)
    }
    module.hot.accept("./MultipleOssUpload.vue?vue&type=template&id=1fc2d48c&scoped=true&", function () {
      api.rerender('1fc2d48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MultipleOssUpload.vue"
export default component.exports